import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { FAQ_ITEMS, FAQ_HEADER } from '../constants';
import { useLanguage } from '../LanguageContext';

export default function FAQ() {
  const { lang }    = useLanguage();
  const items       = FAQ_ITEMS[lang];
  const header      = FAQ_HEADER[lang];
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(prev => (prev === i ? null : i));

  return (
    <section className="pb-section pb-section-pad" id="faq" data-testid="pb-faq">
      <div className="pb-container">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 64, alignItems: 'start' }}>
          {/* Left */}
          <div style={{ position: 'sticky', top: 88 }}>
            <div className="pb-label">{header.label}</div>
            <h2 className="pb-section-title" style={{ fontSize: 'clamp(28px, 3vw, 40px)' }}>
              {header.title}
            </h2>
            <p style={{ fontSize: 14, color: 'var(--pb-muted)', lineHeight: 1.75, marginTop: 12 }}>
              {header.subText}
            </p>
            <a
              href="mailto:cockpit@pitboardsuite.com"
              className="pb-btn-outline"
              style={{ display: 'inline-flex', marginTop: 16, fontSize: 14, padding: '9px 18px' }}
              data-testid="pb-faq-contact-btn"
            >
              {header.contactBtn}
            </a>
          </div>

          {/* Right — accordion */}
          <div className="pb-faq-list">
            {items.map((item, i) => (
              <div key={i} className="pb-faq-item" data-testid={`pb-faq-item-${i}`}>
                <button
                  className="pb-faq-trigger"
                  aria-expanded={openIndex === i}
                  onClick={() => toggle(i)}
                  data-testid={`pb-faq-trigger-${i}`}
                >
                  <span className="pb-faq-question">{item.q}</span>
                  <Plus size={18} className={`pb-faq-icon${openIndex === i ? ' open' : ''}`} aria-hidden="true" />
                </button>
                <div className={`pb-faq-answer${openIndex === i ? ' open' : ''}`}>
                  <div className="pb-faq-answer-inner">{item.a}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          #faq .pb-container > div { grid-template-columns: 1fr !important; gap: 32px !important; }
          #faq .pb-container > div > div:first-child { position: static !important; }
        }
      `}</style>
    </section>
  );
}
